<template>
  <div class="page">

    <div class="nav">
      <span :class="navSelected == 'QC检验月分析' ? 'nav-selected' : ''" @click="navToggle('QC检验月分析')">QC检验月分析</span>
      <span>|</span>
      <span :class="navSelected == 'QC检验日分析' ? 'nav-selected' : ''" @click="navToggle('QC检验日分析')">QC检验日分析</span>
      <span>|</span>
      <span :class="navSelected == 'QC检验明细' ? 'nav-selected' : ''" @click="navToggle('QC检验明细')">QC检验明细</span>
    </div>

    <month v-if="navSelected == 'QC检验月分析'" />

    <day v-if="navSelected == 'QC检验日分析'" />

    <detail v-if="navSelected == 'QC检验明细'" />
  </div>
</template>

<script>
import Month from "@/components/QCReport/Month.vue";
import Day from "@/components/QCReport/Day.vue";
import Detail from "@/components/QCReport/Detail.vue";

export default {
  components: {
    Month,
    Day,
    Detail
  },
  data() {
    return {
      navSelected: 'QC检验月分析'
    }
  },
  methods: {
    navToggle(val) {
      this.navSelected = val
    }
  }
}
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .nav-selected {
  color: #38559F;
}
@media screen and (min-width: 500px) {
  .nav {
    display: none;
  }
}
</style>